export const environment = {
    production: false,
    ENV: 'SIT',
    APP_Ocp_Apim_Subscription_Key: '5df71f7631a549abb9a761b046c6209d',
    LUMINA_APP_BASE_URL: "https://lumina-sit.dnv.com",
    LUMINA_APP_CLIENT_ID: "1de9d533-9cf9-4faf-8891-ec3d4a6b7fd6",
    LUMINA_APP_LOGOUT_URL: "https://developer.veracity.com/auth/logout",
    APP_BASE_URL: 'https://testapi.dnv.com/BALUMINA-API-SIT/v0/',
    SERVICE_ID:'abfaf3a7-e104-402e-8ac5-a259832b6dda',
    appInsights: {
        instrumentationKey: '3e81e304-8a01-4471-941c-77f5eec5970f',
      },
};
